<div class="content-parameters">
  <form>
    <h3 class="first">Pais</h3>

    <div class="p-grid">
      <div class="p-col-6">
        <p-selectButton
          class="mu-select-button"
          [options]="countries"
          [(ngModel)]="selectedCountry"
          optionLabel="name"
          name="country"
        ></p-selectButton>
      </div>
    </div>

    <h3 class="first">Ciudad</h3>
    <p-autoComplete
      *ngIf="cities !== null"
      name="city"
      [(ngModel)]="selectedCity"
      field="name"
      [suggestions]="filteredCities"
      (completeMethod)="filterCities($event)"
      (onSelect)="cityCediSelected()"
      [size]="30"
      [minLength]="1"
      placeholder="Ingresa el nombre de la ciudad"
      [dropdown]="true"
    >
      <ng-template let-brand pTemplate="item">
        {{ brand.name }}
      </ng-template>
    </p-autoComplete>

    <h3 class="first">Empresa</h3>
    <p-autoComplete
      *ngIf="companies !== null"
      name="company"
      [(ngModel)]="selectedCompany"
      field="name"
      [suggestions]="filteredCompanies"
      (completeMethod)="filterCompanies($event)"
      (ngModelChange)="updateClientPoints($event)"
      [size]="30"
      [minLength]="1"
      placeholder="Ingresa el nombre de la empresa"
      [dropdown]="true"
    >
      <ng-template let-brand pTemplate="item">
        {{ brand.name }}
      </ng-template>
    </p-autoComplete>

    <h3 class="first">CEDI</h3>
    <div class="create-cedi">
      <p-dropdown
        [options]="clientPointsCompany"
        [(ngModel)]="selectedClientPoint"
        optionLabel="name"
        name="clientPoint"
        filter="true"
      ></p-dropdown>
      <p-button class="p-col-12 p-md-2 p-lg-2" [disabled]="!selectedCompany" label="Crear Cedi" (onClick)="handleModalCedi()"></p-button>
    </div>
    <h3 class="first">Tipo Vehículo</h3>

    <div class="p-grid">
      <div class="p-col-6">
        <p-selectButton
          class="mu-select-button"
          [options]="vehicleTypes"
          [(ngModel)]="selectedVehicleType"
          optionLabel="name"
          name="vehicleType"
        ></p-selectButton>
      </div>
    </div>
    <div>
      <h3 class="first">Fecha del Servicio</h3>
      <p-calendar name="fecha" [(ngModel)]="deliveryDate"></p-calendar>
    </div>
    <div class="p-grid">
      <div class="p-col-12 p-md-4 p-lg-3">
        <h3>Hora Inicio</h3>
        <p-calendar name="startTime" [timeOnly]="true" [(ngModel)]="startTime"></p-calendar>
      </div>
      <div class="p-col-12 p-md-4 p-lg-3">
        <h3>Hora Finalización</h3>
        <p-calendar name="endtime" [timeOnly]="true" [(ngModel)]="endTime"></p-calendar>
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-12 p-md-3 p-lg-4">
        <div>
          <div>
            <h3>Archivo Servicios</h3>
          </div>
          <p-fileUpload
            #fileUploadControl
            id="mu-file-snd-create"
            name="myfile[]"
            auto="true"
            [customUpload]="true"
            (onRemove)="handleFilePending()"
            (onSelect)="handleFilePending()"
            (uploadHandler)="eventUploadExcelFile(fileUploadControl, $event)"
          ></p-fileUpload>
        </div>
        <div class="p-grid">
          <p-button class="p-col-6 p-md-6 p-lg-6" label="Cancelar" (onClick)="cancelMassiveDistribution()"></p-button>

          <p-button
            class="p-col-6 p-md-6 p-lg-6"
            label="Crear Servicio"
            [disabled]="!allowCreateService"
            (onClick)="createMassiveDistribution()"
          ></p-button>
        </div>
      </div>
    </div>
  </form>
</div>
<p-dialog header="Nuevo punto" [(visible)]="showModalCedi" [style]="{ width: '50vw' }">
  <app-create-cedi-point
    [cities]="cities"
    [country]="selectedCountry"
    [company]="selectedCompany"
    [labelbutton]="labelButtonCedi"
    [filtercities]="filteredCities"
    (closecedimodal)="handleModalCedi()"
    (showtoast)="showSuccess()"
    (filteredcities)="filterCities($event)"
  ></app-create-cedi-point>
</p-dialog>
<app-mu-loading-modal-dialog [processingData]="processingExcel"></app-mu-loading-modal-dialog>
<p-toast></p-toast>
